import { createContext } from 'react';
import { Bottle } from '../interfaces';

export default createContext<Bottle[]>([]);
